import React from "react";
import styled from "styled-components";
import { Header, Hero, Heading, Main, AddOns, Footer } from "Components";
import { fonts } from "theme/fonts";

export const Layout = ({
  // header
  headerRegistration,
  headerTitles,
  headerBgImage,
  headerShowLogo,
  headerLogo,
  headerSecondaryText,
  headerCTA,
  // hero
  heroContent,
  heroPadding = "56.25%",
  videoStyle,
  // heading
  heading,
  // main
  subHeading,
  noPadding,
  children,
  // add-ons
  noAddons,
  // site footer
  footerShow = true,
  footerRegistration = false,
  footerShowLogo = false,
  footerLogo,
  footerShowText = false,
  footerText,
  footerPrivacyPolicy,
  // extra
  setModalVisible,
}) => {
  return (
    <SiteContainer>
      <Header
        headerTitles={headerTitles}
        headerShowLogo={headerShowLogo}
        headerLogo={headerLogo}
        headerBgImage={headerBgImage}
        headerRegistration={headerRegistration}
        headerSecondaryText={headerSecondaryText}
        headerCTA={headerCTA}
        setModalVisible={setModalVisible}
      />

      <Hero
        heroContent={heroContent}
        heroPadding={heroPadding}
        videoStyle={videoStyle}
      />

      <Heading heading={heading} />

      <Main subHeading={subHeading} children={children} noPadding={noPadding} />

      <AddOns noAddons={noAddons} />

      <Footer
        footerShow={footerShow}
        footerRegistration={footerRegistration}
        footerShowLogo={footerShowLogo}
        footerLogo={footerLogo}
        footerShowText={footerShowText}
        footerText={footerText}
        footerPrivacyPolicy={footerPrivacyPolicy}
      />
    </SiteContainer>
  );
};

// ======== SITE CONTAINER ======== //

const SiteContainer = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: ${fonts.default};
  margin: 0 auto;
  max-width: 2000px;
  min-height: 100vh;
  position: relative;
  width: 100%;

  @media ${(props) => props.theme.maxMedia.large} {
    box-shadow: 0 0 3px 0px rgba(0, 0, 0, 0.65);
  }
`;

// ======== VIEW TEMPLATE ======== //

export const BodySection = styled.div`
  font-family: "Arial";
  text-align: center;
  font-size: 18px;
  max-width: 900px;
  margin: 0 auto;
  color: #ffffff;
  padding: 0 15px 50px 15px;
`;
